export default function BrandStory() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">
              关于愽彩糖果
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                愽彩糖果创立于2018年，是一家专注于缤纷糖果在线销售与批发的综合型糖果平台。我们深知每一颗糖果都承载着甜蜜与快乐，因此从原料采购到品质把控，每一个环节都精益求精。
              </p>
              <p>
                我们的产品线涵盖<strong>水果糖果、巧克力糖果、软糖、棒棒糖、糖果礼盒</strong>以及<strong>散装糖果批发</strong>六大品类，拥有超过200款精选糖果产品。无论是日常零食、节日礼品还是商业采购，都能在愽彩糖果找到满意的选择。
              </p>
              <p>
                我们与国内外多家优质糖果生产商建立了长期合作关系，确保每一批产品都经过严格的质量检测。同时，我们不断拓展产品品类，引入更多创新口味和创意包装，让糖果不仅是零食，更是传递情感的甜蜜载体。
              </p>
              <p>
                未来，愽彩糖果将继续秉承「甜蜜每一刻」的品牌理念，为更多消费者带来高品质、多样化的糖果选购体验。
              </p>
            </div>
          </div>
          <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20candy%20shop%20interior%20with%20colorful%20candy%20jars%20on%20wooden%20shelves%2C%20soft%20natural%20lighting%20streaming%20through%20window%2C%20cozy%20and%20charming%20atmosphere%2C%20professional%20interior%20photography%2C%20vibrant%20colors%2C%20clean%20and%20organized%20display&width=800&height=600&seq=about-brand&orientation=landscape"
              alt="愽彩糖果品牌故事"
              title="愽彩糖果 - 品牌故事"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          {[
            { num: '200+', label: '精选糖果' },
            { num: '50万+', label: '服务客户' },
            { num: '98%', label: '好评率' },
            { num: '6', label: '糖果品类' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-5 bg-background-100 rounded-lg">
              <div className="text-2xl md:text-3xl font-heading text-accent-500 mb-1">{stat.num}</div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}